import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import './HomeNavigation.css'
import HomeHeader from './HomeHeader'
import HomeNavLinks from './HomeNavLinks'
import SideDrawer from '../../../admin/components/SideDrawer'
import Backdrop from '../UIElements/Backdrop'
import playerStatsLogo from '../../../images/playerStats_transparent.png'
import adminLogo from '../../../images/admin_transparent.png'

const StatsAndStandingsHomeNavigation = (props) => {
	const [drawerIsOpen, setDrawerIsOpen] = useState(false)

	const { pathname } = useLocation()
	const adminPage = pathname === '/admin/login'

	const openDrawerHandler = () => {
		setDrawerIsOpen(true)
	}

	const closeDrawerHandler = () => {
		setDrawerIsOpen(false)
	}

	return (
		<React.Fragment>
			{drawerIsOpen && <Backdrop onClick={closeDrawerHandler} />}
			<SideDrawer show={drawerIsOpen} onClick={closeDrawerHandler}>
				<nav className='home-navigation__drawer-nav'>
					<HomeNavLinks leagueId={props.leagueId} />
				</nav>
			</SideDrawer>
			<HomeHeader>
				<button
					className='home-navigation__menu-btn'
					onClick={openDrawerHandler}
				>
					<span />
					<span />
					<span />
				</button>
				{/* <h1 className='home-navigation__title'>Player Stats</h1> */}
				{/* <div className='headerWidth'>
					<img src={playerStatsLogo} className='teamHistoryLogo' />
				</div> */}
				{!adminPage && (
					<div className='headerWidth'>
						<img src={playerStatsLogo} className='teamHistoryLogo' />
					</div>
				)}
				{adminPage && (
					<div className='headerWidth'>
						<img src={adminLogo} className='adminLogo' />
					</div>
				)}
				<nav className='home-navigation__header-nav'>
					<HomeNavLinks leagueId={props.leagueId} />
				</nav>
			</HomeHeader>
		</React.Fragment>
	)
}

export default StatsAndStandingsHomeNavigation
